import React from 'react';
import { Hero } from './Hero';
import { PainPoints } from './PainPoints';
import { Solution } from './Solution';
import { Bonuses } from './Bonuses';
import { Benefits } from './Benefits';
import { Offer } from './Offer';
import { Guarantee } from './Guarantee';
import { Testimonials } from './Testimonials';
import { FAQ } from './FAQ';
import { FinalCTA } from './FinalCTA';
import { Footer } from './Footer';
import { StickyCTA } from './StickyCTA';
export function LandingPage() {
  return <div className="min-h-screen bg-white font-sans selection:bg-ocean-teal-light selection:text-ocean-teal-dark" data-id="element-122">
      <main data-id="element-123">
        <Hero data-id="element-124" />
        <PainPoints data-id="element-125" />
        <Solution data-id="element-126" />
        <Bonuses data-id="element-127" />
        <Benefits data-id="element-128" />
        <Offer data-id="element-129" />
        <Guarantee data-id="element-130" />
        <Testimonials data-id="element-131" />
        <FAQ data-id="element-132" />
        <FinalCTA data-id="element-133" />
      </main>
      <Footer data-id="element-134" />
      <StickyCTA data-id="element-135" />
    </div>;
}